import React from 'react';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import { routeMappings } from '../../constants';

const ResearchQuestionsPage = React.lazy(() => import('./ResearchQuestionsPage'));
const ApplicationFormPage = React.lazy(() => import('./ApplicationFormPage'));
const EeoFormPage = React.lazy(() => import('./EeoFormPage'));
const OFCCPPage = React.lazy(() => import('./OFCCPPage'));
const YourResponsibilityPage = React.lazy(() => import('./YourResponsibilityPage'));
const WelcomePage = React.lazy(() => import('./WelcomePage'));

const configurablePageRoutes = [
  {
    path: routeMappings['RESEARCH_QUESTIONS'],
    exact: true,
    component: withBasicDetails(ResearchQuestionsPage),
  },
  {
    path: routeMappings['APPLICATION_FORM'],
    exact: true,
    component: withBasicDetails(ApplicationFormPage),
  },
  {
    path: routeMappings['EEO'],
    exact: true,
    component: withBasicDetails(EeoFormPage),
  },
  {
    path: routeMappings['OFCCP'],
    exact: true,
    component: withBasicDetails(OFCCPPage),
  },
  {
    path: routeMappings['YOUR_RESPONSIBILITY'],
    exact: true,
    component: withBasicDetails(YourResponsibilityPage),
  },
  {
    path: `${routeMappings['WELCOME']}`,
    exact: true,
    component: withBasicDetails(WelcomePage),
  },
];

export default configurablePageRoutes;
